import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.activeMap = null;
    this.activeMarkers = [];
    this.pendingMapConstruct = false;
    this.scriptsLoaded = false;

    window.addEventListener('plp-map-open', this.constructMap.bind(this));
    window.addEventListener('plp-map-update-markers', this.updateMarkers.bind(this));

    this.appendScripts();
  }

  appendScripts() {
    const leafletCSS = document.createElement('link');
    leafletCSS.rel = 'stylesheet';
    leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(leafletCSS);

    const clusterCSS = document.createElement('link');
    clusterCSS.rel = 'stylesheet';
    clusterCSS.href = 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css';
    document.head.appendChild(clusterCSS);

    const leafletScript = document.createElement('script');
    leafletScript.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    document.head.appendChild(leafletScript);

    leafletScript.onload = () => {
      const clusterScript = document.createElement('script');
      clusterScript.src = 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js';
      document.head.appendChild(clusterScript);

      clusterScript.onload = () => {
        this.scriptsLoaded = true;
        if (this.pendingMapConstruct) {
          this.pendingMapConstruct = false;
          this.constructMap();
        }
      };
    };
  }

  validListingsOnly(listing) {
    return listing.coordinates_present;
  }

  getListingData() {
    return JSON.parse(
      document.querySelector('.js-Listings__grid-coordinates').innerHTML
    ).filter(this.validListingsOnly);
  }

  constructMap() {
    if (!this.scriptsLoaded) {
      this.pendingMapConstruct = true;
      return;
    }

    if (!this.activeMap) {
      this.activeMap = this.createMap();
    }
    this.fillMap();
  }

  createMap() {
    const map = L.map('listings-grid-map').setView([0, 0], 2);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    return map;
  }

  fillMap() {
    if (this.markerClusterGroup) {
      this.activeMap.removeLayer(this.markerClusterGroup);
    }
    this.markerClusterGroup = L.markerClusterGroup();

    const listingDataList = this.getListingData();
    const bounds = [];

    listingDataList.forEach(listingData => {
      const { latitude, longitude } = listingData.coordinates;

      const icon = L.divIcon({
        className: 'ListingsMap__price-marker',
        html: `<div class="ListingsMap__price-bubble">$${listingData.min_rate}</div>`,
        iconSize: null
      });

      const marker = L.marker([latitude, longitude], { icon });
      marker.bindPopup(this.popupContent(listingData), { maxWidth: 300 });
      this.markerClusterGroup.addLayer(marker);
      bounds.push([latitude, longitude]);
    });

    this.activeMap.addLayer(this.markerClusterGroup);

    if (bounds.length > 0) {
      this.activeMap.fitBounds(bounds);
    }
  }

  updateMarkers() {
    if (this.activeMap) {
      this.fillMap();
    }
  }

  popupContent(listingData) {
    const starSvg = document.querySelector('.js-Listings__star-icon svg');

    if (listingData.review_is_valid) {
      return `<div class='google_info_window'>
        <div class='ListingsMap__image-container'>
          <img src="${listingData.image_source}">
        </div>
        <a href='${listingData.link_path}' class="ListingSingleMap__link" style="text-decoration: none;" target="_blank">
          <h3 class='ListingSingleMap__title'>${listingData.title}</h3>
        </a>
        <div class='ListingsMap__reviews-container'>
          ${starSvg ? starSvg.outerHTML : ''}
          <span class='ListingSingleMap__reviews-rating'>${listingData.review_rating}</span>
          <span class='ListingSingleMap__reviews-quantity'>(${listingData.reviews_total})</span>
        </div>
        <h5 class='ListingSingleMap__price-information'>Starting $${listingData.min_rate} / night</h5>
      </div>`;
    } else {
      return `<div class='google_info_window'>
        <div class='ListingsMap__image-container'>
          <img src="${listingData.image_source}">
        </div>
        <a href='${listingData.link_path}' style="text-decoration: none;" target="_blank" class="ListingSingleMap__link">
          <h3 class='ListingSingleMap__title'>${listingData.title}</h3>
          <h5 class='ListingSingleMap__price-information'>From $${listingData.min_rate} / night</h5>
        </a>
      </div>`;
    }
  }
}
